import type { PermissionsContextValue } from '@hetivo/hetivo-lib-front-utils';

type PermissionChecker = Pick<PermissionsContextValue, 'hasPermission'>;

/**
 * Whether the user may open the territory settings route (/settings/territories/$territoryId).
 * Shared by that route's guard and the settings layout's master-context redirect so the two
 * cannot drift apart — a mismatch causes a /settings ↔ territory redirect loop.
 */
export function canAccessTerritorySettings({ hasPermission }: PermissionChecker): boolean {
  return hasPermission('territories:list') || hasPermission('locations:list');
}

/**
 * Whether the user may open the location settings route (/settings/locations/$locationId).
 * Shared by that route's guard and the settings layout's master-context redirect.
 */
export function canAccessLocationSettings({ hasPermission }: PermissionChecker): boolean {
  return hasPermission('locations:list');
}
